export default "__VITE_ASSET__Auoq7U1o__"